import { useTranslation } from '@frontend/i18n';
import { GenericFieldProps } from '../types';
import { Setting } from './setting';
import { TextDropdownField } from './text-dropdown-field';

type HeightSettingProps = GenericFieldProps & {
  options?: string[];
  title?: string;
};

const defaultOptions = ['auto', '120px', '240px', '320px', '480px'];

export const HeightSetting = ({ options = defaultOptions, title, ...fieldProps }: HeightSettingProps) => {
  const content = <HeightSettingContent {...fieldProps} options={options} />;
  return title ? <Setting title={title}>{content}</Setting> : content;
};

type HeightSettingContentProps = GenericFieldProps & {
  options: string[];
};

const HeightSettingContent = ({ options, ...fieldProps }: HeightSettingContentProps) => {
  const { t } = useTranslation('content-composer');

  return (
    <Setting.Item label={t('Height')}>
      <TextDropdownField {...fieldProps} options={options} defaultValue='auto' />
    </Setting.Item>
  );
};
